/**
 * navigation-image-map
 */

import $ from 'jquery';

// Module dependencies
import 'protons';

// Module template
import './_navigation-image-map.twig';
import './_navigation-image-map.css';

export const name = 'navigation-image-map';

export const defaults = {
  dummyClass: 'js-navigation-image-map-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context) {
  // Find our component within the DOM
  // eslint-disable-next-line no-undef
  const navigationImageMaps = once(
    'navigation-image-map--init',
    '.navigation-image-map',
    $context
  );

  // Bail if component does not exist
  if (!navigationImageMaps.length) {
    return;
  }

  // Converst to jQuery list.
  const $navigationImageMap = $(navigationImageMaps);

  // Adds handlers for triggers.
  $navigationImageMap.each(function initializeNavImageMap() {
    let triggered = false;
    const $content = $(this).find('.navigation-image-map__content');
    $content.addClass('navigation-image-map__content--swap');

    $('.navigation-image-map-pin__trigger', this).click(
      function pinTriggerClickHandle(e) {
        e.preventDefault();
        if (
          triggered ||
          $(this).is('.navigation-image-map-pin__trigger--active')
        ) {
          return;
        }

        // Sets semaphore.
        const $trigger = $(this);
        triggered = true;

        // Updates triggers.
        $trigger
          .parents('.navigation-image-map__pins')
          .find('.navigation-image-map-pin__trigger--active')
          .removeClass('navigation-image-map-pin__trigger--active')
          .end()
          .end()
          .addClass('navigation-image-map-pin__trigger--active');

        // Hides content area and swaps text.
        $content.addClass('navigation-image-map__content--swap');
        setTimeout(function swapContents() {
          $content.empty();
          const $data = $trigger
            .parent()
            .find('.navigation-image-map-pin__data')
            .clone()
            .html();
          $content.append($data);
          $content.removeClass('navigation-image-map__content--swap');

          setTimeout(function clearSemaphore() {
            // Clears semaphore.
            triggered = false;
          }, 250);
        }, 250);
      }
    );
  });
}

export default enable;
